module.exports = __webpack_public_path__ + "img/block6-card7.7b869c6a.svg";